import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";

/**
 * Automatically imports all the modules and exports as a single module object
 */
var requireModule = require.context('.', false, /\.store\.js$/);

var modules = {};
requireModule.keys().forEach(function (filename) {
  // create the module name from fileName
  // remove the store.js extension and capitalize
  var moduleName = filename.replace(/(\.\/|\.store\.js)/g, '').replace(/^\w/, function (c) {
    return c.toUpperCase();
  });
  modules[moduleName] = requireModule(filename).default || requireModule(filename);
});
export default modules;